import { ParticipationCompatibilityPage } from './ParticipationCompatibilityPage';

/** Historical resource routes remain bookmark-compatible without generic CRUD. */
export const disqualifications = {
  list: ParticipationCompatibilityPage,
  show: ParticipationCompatibilityPage,
  create: ParticipationCompatibilityPage,
  edit: ParticipationCompatibilityPage,
};
